/**
 * Chapter navigation — next/previous chapter, chapter IDs.
 */
import { TOC, getBookInfo } from '../constants/toc.js';
/**
 * Get the next chapter location, or null if at the end.
 */
export function getNextChapter(location) {
    const book = getBookInfo(location.testamentIndex, location.bookIndex);
    if (!book)
        return null;
    if (location.chapterIndex + 1 < book.chapterCount) {
        return {
            testamentIndex: location.testamentIndex,
            bookIndex: location.bookIndex,
            chapterIndex: location.chapterIndex + 1,
            verseIndex: 0,
        };
    }
    const testament = location.testamentIndex === 0 ? TOC.OT : TOC.NT;
    if (location.bookIndex + 1 < testament.length) {
        return {
            testamentIndex: location.testamentIndex,
            bookIndex: location.bookIndex + 1,
            chapterIndex: 0,
            verseIndex: 0,
        };
    }
    if (location.testamentIndex === 0) {
        return { testamentIndex: 1, bookIndex: 0, chapterIndex: 0, verseIndex: 0 };
    }
    return null;
}
/**
 * Get the previous chapter location, or null if at the beginning.
 */
export function getPreviousChapter(location) {
    if (location.chapterIndex > 0) {
        return {
            testamentIndex: location.testamentIndex,
            bookIndex: location.bookIndex,
            chapterIndex: location.chapterIndex - 1,
            verseIndex: 0,
        };
    }
    if (location.bookIndex > 0) {
        const testament = location.testamentIndex === 0 ? TOC.OT : TOC.NT;
        const prevBook = testament[location.bookIndex - 1];
        return {
            testamentIndex: location.testamentIndex,
            bookIndex: location.bookIndex - 1,
            chapterIndex: prevBook.chapterCount - 1,
            verseIndex: 0,
        };
    }
    if (location.testamentIndex === 1) {
        const lastOTBook = TOC.OT[TOC.OT.length - 1];
        return {
            testamentIndex: 0,
            bookIndex: TOC.OT.length - 1,
            chapterIndex: lastOTBook.chapterCount - 1,
            verseIndex: 0,
        };
    }
    return null;
}
/**
 * Get a unique chapter identifier string.
 */
export function getChapterId(location) {
    const book = getBookInfo(location.testamentIndex, location.bookIndex);
    if (!book)
        return 'unknown';
    return `${book.fileName}-${location.chapterIndex}`;
}
/**
 * Parse a chapter ID back to location.
 */
export function parseChapterId(id) {
    const match = id.match(/^(.+)-(\d+)$/);
    if (!match)
        return null;
    const [, fileName, chapterStr] = match;
    const chapterIndex = parseInt(chapterStr, 10);
    for (let t = 0; t < 2; t++) {
        const testament = t === 0 ? TOC.OT : TOC.NT;
        for (let b = 0; b < testament.length; b++) {
            if (testament[b].fileName === fileName) {
                return { testamentIndex: t, bookIndex: b, chapterIndex, verseIndex: 0 };
            }
        }
    }
    return null;
}
//# sourceMappingURL=chapter-navigation.js.map